import apiClient from './client';

export interface TimeBlock {
  id?: number;
  start_time: string;
  end_time: string;
  appointment_duration: number;
}

export interface WorkingDay {
  id: number;
  professional: number;
  day_of_week: number;
  day_of_week_display: string;
  time_blocks: TimeBlock[];
}

export interface TimeBlockCreateRequest {
  working_day: number;
  start_time: string;
  end_time: string;
  appointment_duration: number;
}

export interface WorkingDayCreateRequest {
  professional: number;
  day_of_week: number;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

/**
 * Schedule API Service
 * Manages working days and time blocks for professionals
 */
export const scheduleAPI = {
  /**
   * Get all working days for a professional
   */
  getWorkingDays: (professionalId: number) =>
    apiClient.get<PaginatedResponse<WorkingDay>>('/working-days/', { params: { professional: professionalId } }),

  /**
   * Create a working day
   */
  createWorkingDay: (data: WorkingDayCreateRequest) =>
    apiClient.post<WorkingDay>('/working-days/', data),

  /**
   * Delete a working day
   */
  deleteWorkingDay: (id: number) =>
    apiClient.delete(`/working-days/${id}/`),

  /**
   * Get time blocks for a working day
   */
  getTimeBlocks: (workingDayId: number) =>
    apiClient.get<TimeBlock[]>('/time-blocks/', { params: { working_day: workingDayId } }),

  /**
   * Create a time block
   */
  createTimeBlock: (data: TimeBlockCreateRequest) =>
    apiClient.post<TimeBlock>('/time-blocks/', data),

  /**
   * Update a time block
   */
  updateTimeBlock: (id: number, data: Partial<TimeBlockCreateRequest>) =>
    apiClient.patch<TimeBlock>(`/time-blocks/${id}/`, data),

  /**
   * Delete a time block
   */
  deleteTimeBlock: (id: number) =>
    apiClient.delete(`/time-blocks/${id}/`),
};
